/* eslint-disable camelcase */
import { fireLinkTag } from './tagManager';

/**
 *
 * @param {string} product_id
 * @param {number} num_offers
 */
const tagSecondaryPromo = (product_id, num_offers) => {
  const data = {
    event_name: 'special offer click',
    product_id,
    num_offers,
  };
  fireLinkTag(data);
};

export default tagSecondaryPromo;
